import { render, staticRenderFns } from "./productSolution.vue?vue&type=template&id=32ca7622&scoped=true&"
import script from "./productSolution.vue?vue&type=script&lang=js&"
export * from "./productSolution.vue?vue&type=script&lang=js&"
import style0 from "./productSolution.vue?vue&type=style&index=0&id=32ca7622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ca7622",
  null
  
)

export default component.exports